import { useGame } from "./GameContext";
import HintList from "./HintList";
import HintDetail from "./HintDetail";
import Suspect from "../suspect/suspect";

export default function HintContainer() {
  const { hintView, suspectImgs } = useGame();

  if (hintView === "NONE") return null;

  return (
    <div className="hint_overlay storage_box ans0002 box_storage_bg ">
      {hintView === "LIST" && <HintList />}
      {hintView === "DETAIL" && <HintDetail />}
      {hintView === "SUSPECT" && (
        <Suspect suspectImgs={suspectImgs} isHintMode={true} timerMode="run" />
      )}
    </div>
  );
}
